const REGION_DURATION = "last_6_months";

const DASHBOARD_ONPREM_SORT_OPTIONS = [
  { label: "Sort By: CVE (High to Low)", value: "cve_desc" },
  { label: "Sort By: CVE (Low to High)", value: "cve_asc" },
  { label: "Sort By: Assets (High to Low)", value: "assets_desc" },
  { label: "Sort By: Assets (Low to High)", value: "assets_asc" },
  {
    label: "Sort By: Misconfigurations (High to Low)",
    value: "vulnerabilities_desc",
  },
  {
    label: "Sort By: Misconfigurations (Low to High)",
    value: "vulnerabilities_asc",
  },
  {
    label: "Sort By: Security Score (High to Low)",
    value: "securityscore_desc",
  },
  {
    label: "Sort By: Security Score (Low to High)",
    value: "securityscore_asc",
  },
  { label: "Sort By: Compliance (High to Low)",
     value: "compliance_desc" },
  { label: "Sort By: Compliance (Low to High)",
     value: "compliance_asc" },
];

const DEFAULT_ONPREM_CLASSIFICATION_SORT = "assets_desc";

const DASHBOARD_CLOUD_ACCOUNTS_SORT_OPTIONS = [
  { label: "Sort By: Resources (High to Low)", value: "resources_desc" },
  { label: "Sort By: Resources (Low to High)", value: "resources_asc" },
  {
    label: "Sort By: Security Score (High to Low)",
    value: "securityscore_desc",
  },
  {
    label: "Sort By: Security Score (Low to High)",
    value: "securityscore_asc",
  },
  {
    label: "Sort By: Misconfigurations (High to Low)",
    value: "misconfigurations_desc",
  },
  {
    label: "Sort By: Misconfigurations (Low to High)",
    value: "misconfigurations_asc",
  },
  { label: "Sort By: Compliance (High to Low)", value: "compliance_desc" },
  { label: "Sort By: Compliance (Low to High)", value: "compliance_asc" },
];

const DEFAULT_CLOUD_ACCOUNTS_SORT = "resources_desc";

const SEVERITY_FILTER_OPTIONS = [
  { value: "all", label: "All" },
  { value: "critical", label: "Critical" },
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "low", label: "Low" },
];

const DEFAULT_SEVERITY_FILTER = "all";

export {
  DEFAULT_ONPREM_CLASSIFICATION_SORT,
  DASHBOARD_ONPREM_SORT_OPTIONS,
  REGION_DURATION,
  DASHBOARD_CLOUD_ACCOUNTS_SORT_OPTIONS,
  DEFAULT_CLOUD_ACCOUNTS_SORT,
  SEVERITY_FILTER_OPTIONS,
  DEFAULT_SEVERITY_FILTER,
};
